<template>
  <form id="registerForm" @submit.prevent="registration">
    <PaymentFormBasic
      :check="check"
      :email="email"
      :email-disabled="true"
      :login-flag="false"
      :solid="true"
      @basic-changed="update"
    />
    <div class="pt-3 mb-8">
      <PaymentFormInput
        v-model:value="password"
        :name="'new-password'"
        autocomplete="new-password"
        :title="t('auth.password')"
        type="password"
        :required="true"
      />
      <div
        v-if="passwordValidation"
        class="mx-1 mt-2.5 flex gap-1 items-center"
      >
        <icon-warning
          v-if="passwordValidation.indicator === 'red'"
          class="text-red text-[15px]"
        />
        <icon-success
          v-if="passwordValidation.indicator === 'green'"
          class="text-green text-[15px]"
        />
        <span
          :class="`text-[11px] font-normal text-${passwordValidation.indicator}`"
        >
          {{ passwordValidation.status }}
        </span>
      </div>
    </div>
    <div v-if="errorMessage" class="text-red text-sm mb-4">
      {{ errorMessage }}
    </div>
    <BaseButton
      type="primary"
      buttonType="submit"
      :label="t('auth.join')"
      password
      :height="52"
      class="!w-full"
      :loading="registering"
      @click="registration"
    />
  </form>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import type { IField } from "./../../../types/general";
const { t } = useI18n();
const { register } = useAuth();
const props = defineProps({
  email: {
    type: String,
    default: "",
  },
});
const passwordValidation = ref<{
  status: string;
  indicator: "red" | "green";
} | null>(null);
const formData = ref<IField[]>();
const password = ref<string>("");
const isValid = ref<boolean>(true);
const registering = ref<boolean>(false);
const update = (val: IField[]): void => {
  formData.value = val;
};
const emit = defineEmits(["close"]);
const check = ref(false);
const errorMessage = ref<string | null>(null); // To display error message
const regularExpression = /^.{8,80}$/;

watch(
  password,
  (val) => {
    if (password.value) {
      if (password.value.length < 8) {
        passwordValidation.value = {
          status: t("auth.atLeast8Characters"),
          indicator: "red",
        };
      } else {
        const res = regularExpression.test(val);

        if (res)
          passwordValidation.value = {
            status: t("auth.looksGood"),
            indicator: "green",
          };
        else {
          passwordValidation.value = {
            status: t("auth.passwordMustBe8Characters"),
            indicator: "red",
          };
        }
      }
    } else {
      passwordValidation.value = null;
    }
  },
  { immediate: true, deep: true }
);
function validateForm(): boolean {
  isValid.value = true;
  errorMessage.value = null;
  formData.value?.forEach((item: IField) => {
    if (!item.value || !password.value) {
      isValid.value = false;
      errorMessage.value = t("auth.allFieldsMustBeFilled");
      return false;
    } else {
      return true;
    }
  });
  return isValid.value;
}
const registration = async (): Promise<void> => {
  //TODO should validate inside form component
  if (validateForm()) {
    registering.value = true;
    errorMessage.value = null;
    if (
      passwordValidation.value?.indicator === "green" &&
      isValid &&
      formData.value
    ) {
      const res = await register({
        first_name: formData.value[0].value,
        last_name: formData.value[1].value,
        email: formData.value[2].value,
        phone_number: formData.value[3].value,
        phone_country_code: formData.value[4].value,
        password: password.value,
      });
      if (res) emit("close");
    }
    registering.value = false;
  }
};
</script>
